import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import analyticImg from '../../Assets/images/analytic.png';
import progressImg from '../../Assets/images/progress.png';
import overviewImg from '../../Assets/images/overview.png';
import LazyCardMedia from 'Components/LazyCardMedia';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { analyticsColumns, overViewColumn, progressColumn } from '../../utils/constants'
import LineChartWrapper from '../../Components/Charts/LineChartWrapper';
import PieChartWrapper from '../../Components/Charts/PieChartWrapper';
import GenericTable from 'Components/GenericTable';
import BarHorizontalChartWrapper from './component/BarHorizontalChartWrapper';
import { useHistory } from 'react-router';
import { iconWellStyles, interactiveCardStyles, pageEyebrowStyles, pageTitleTextStyles, surfaceCardStyles } from '../../theme/commonStyles';
import ChartContainer from 'Components/Charts/ChartContainer';
import { ReportServices } from '../../Services/ReportServices';
import { USER_ROLES } from 'utils/constants';
import { SkillsAndTransformation } from 'Services/SkillsAndTransformation';
import { Dashboard } from 'Services/DashboardService';
import { notify, saveJsonAsCsv } from 'utils';
import { RouteSkeleton } from '../../Components/RouteTransition';

const reportService = new ReportServices();
const skillsAndTransformation = new SkillsAndTransformation();
const dashboardService = new Dashboard();

const useStyles = makeStyles((theme) => ({
    page: {
        width: '100%',
        padding: 0,
    },
    pageHeader: {
        marginBottom: theme.spacing(2.5),
    },
    pageEyebrow: {
        ...pageEyebrowStyles,
        marginBottom: theme.spacing(0.5),
    },
    pageTitle: {
        ...pageTitleTextStyles,
        marginBottom: theme.spacing(0.5),
    },
    pageDescription: {
        color: '#647184',
        fontSize: '0.875rem',
        lineHeight: 1.55,
        maxWidth: 640,
    },
    section: {
        marginTop: theme.spacing(3),
    },
    root: {
        ...interactiveCardStyles,
        width: '100%',
        height: '100%',
    },
    content: {
        padding: theme.spacing(2, 2.25),
        '&:last-child': {
            paddingBottom: theme.spacing(2),
        },
    },
    coverWell: {
        ...iconWellStyles,
        width: 48,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        [theme.breakpoints.down('xs')]: {
            width: 40,
            height: 40,
        },
    },
    cover: {
        width: 28,
        height: 28,
        backgroundSize: 'contain',
        [theme.breakpoints.down('xs')]: {
            width: 24,
            height: 24,
        },
    },
    subTitle: {
        color: '#647184',
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.35,
    },
    title: {
        color: '#263548',
        fontSize: '0.875rem',
        fontWeight: 700,
        paddingTop: 4,
        lineHeight: 1.35,
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.8125rem',
        },
    },
    btn: {
        fontSize: '0.75rem',
        fontWeight: 600,
        padding: '6px 14px',
        borderRadius: 8,
        textTransform: 'none',
    },
    cardActions: {
        padding: theme.spacing(0, 2.25, 2),
    },
    reportCardRoot: {
        minHeight: 132,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    reportCardTitle: {
        color: '#647184',
        fontSize: '0.8125rem',
        fontWeight: 600,
        lineHeight: 1.35,
        marginBottom: theme.spacing(1),
        textAlign: 'left',
    },
    reportCardValue: {
        color: theme.palette.primary.main,
        fontSize: '1.75rem',
        fontWeight: 700,
        letterSpacing: '-0.02em',
        lineHeight: 1.2,
        textAlign: 'left',
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.5rem',
        },
    },
    panel: {
        ...surfaceCardStyles,
        padding: theme.spacing(2, 2.25),
        width: '100%',
        overflow: 'auto',
        boxSizing: 'border-box',
        height: '100%',
    },
    panelTitle: {
        color: '#263548',
        fontSize: '0.9375rem',
        fontWeight: 700,
        marginBottom: theme.spacing(1.5),
        lineHeight: 1.35,
    },
    sectionHeading: {
        color: '#263548',
        fontSize: '0.9375rem',
        fontWeight: 700,
        margin: 0,
        marginBottom: theme.spacing(1.5),
        lineHeight: 1.35,
    },
    sectionHeaderRow: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 8,
        marginBottom: theme.spacing(1.5),
    },
    viewAllLink: {
        padding: 0,
        border: 0,
        background: 'none',
        color: theme.palette.primary.main,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: '0.8125rem',
        fontWeight: 600,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    chartAxisLabel: {
        margin: 0,
        marginTop: theme.spacing(1),
        textAlign: 'center',
        fontSize: '0.75rem',
        fontWeight: 600,
        color: '#647184',
    },
    chartScroll: {
        overflowX: 'auto',
        width: '100%',
    },
}));

const ReportCard = ({ title, value }) => {
    const classes = useStyles();

    return (
        <Card className={`${classes.root} ${classes.reportCardRoot}`} elevation={0}>
            <CardContent className={classes.content}>
                <Typography className={classes.reportCardTitle}>
                    {title}
                </Typography>
                <Typography className={classes.reportCardValue}>
                    {value}
                </Typography>
            </CardContent>
        </Card>
    )
}

const Report = ({ title, subTitle, img, handleDownload, handleView, type, downloadReportLoading }) => {
    const classes = useStyles();
    const handleViewItem = () => {
        handleView(type)
    }

    return (
        <Card className={classes.root} elevation={0}>
            <CardContent className={classes.content}>
                <Grid container spacing={1} alignItems="center">
                    <Grid item>
                        <div className={classes.coverWell}>
                            <LazyCardMedia
                                className={classes.cover}
                                image={img}
                            />
                        </div>
                    </Grid>
                    <Grid item xs>
                        <Typography className={classes.subTitle}>
                            {title}
                        </Typography>
                        <Typography className={classes.title}>
                            {subTitle}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions className={classes.cardActions}>
                <Button
                    size="small"
                    onClick={handleViewItem}
                    variant="outlined"
                    className={classes.btn}
                    color="primary"
                >
                    View Data
                </Button>
            </CardActions>
        </Card>
    )
}

const Reporting = () => {
    let userRole = localStorage.getItem("role");
    const history = useHistory();
    const classes = useStyles();
    const [progressOnCoursesList, setProgressOnCoursesList] = React.useState({
        name: 'Course Progress',
        type: 'bar',
        data: []
    });
    const [dataKeyYAxis, setDataKeyYAxis] = React.useState([]);
    const [lineChartData, setLineChartData] = React.useState({ data: [], xAxis: [] });
    const [recommendedCourseslist, setRecommendedCourseslist] = React.useState([]);
    const [bestCourses, setBestCourses] = React.useState([]);
    const [userReportCounts, setUserReportCounts] = React.useState({
        totalCourseCount: 0,
        activeCourseCount: 0,
        completedCourseCount: 0,
        selfLearing: 0,
        inactiveUserCount: 0,
        activeUsersCount: 0,
        assignedLiceCount: 0
    });
    const [downloadReportLoading, setDownloadReportLoading] = React.useState({
        analytics: false,
        progress: false,
        overview: false
    });
    const [pageLoading, setPageLoading] = React.useState(true);

    const getCourseCatalogue = async () => {
        const graphData = await dashboardService.getPopularCourseGraph();
        if (graphData?.data && graphData?.data.length) {
            let courseData = [...graphData.data];
            courseData = (courseData.length > 10) ? courseData.slice(0, 10) : courseData;
            setRecommendedCourseslist(courseData);
        }
    }

    const getUserOverviewReportCount = async () => {
        const countRes = await reportService.getUserOverviewCount();
        if (countRes && countRes.data) {
            const { active_courses, completed_courses, total_license_count, courses, learning_completion } = countRes.data;
            setUserReportCounts({
                assignedLiceCount: total_license_count,
                activeCourseCount: active_courses,
                totalCourseCount: courses,
                completedCourseCount: completed_courses,
                selfLearing: (learning_completion?.course_completion__avg && !isNaN(learning_completion?.course_completion__avg)) ? `${parseInt(learning_completion.course_completion__avg)}%` : '0%'
            });
        }
    }

    const getOverviewReportCount = async () => {
        const countRes = await dashboardService.getDetailDashboardCustomer();
        if (countRes && countRes.data) {
            const { active_users, licenses_assigned, inactive_users, active_courses } = countRes?.data || {};
            setUserReportCounts({
                ...userReportCounts,
                activeUsersCount: active_users,
                assignedLiceCount: licenses_assigned,
                inactiveUserCount: inactive_users,
                activeCourseCount: active_courses
            });
        }
    }

    const getReportsGraphData = async () => {
        const graphData = await dashboardService.getPopularCourseGraph();
        if (graphData?.data && graphData?.data.length) {
            const courseData = [...graphData.data];
            setBestCourses((courseData.length > 5) ? courseData.slice(0, 5).map((crs) => {
                return { name: crs.course_name, count: crs.count };
            }) : courseData.map((crs) => {
                return { name: crs.course_name, count: crs.count };
            }));
            const newData = [...graphData?.data];
            const arrayUniqueByKey = [...new Set(newData.map(item =>
                item.course_name))];
            const graphArr = [];
            const dataArr = [];
            const dataKeyXAxis = [];
            arrayUniqueByKey.forEach(name => {
                const count = newData.filter(itm => itm.course_name === name).reduce((accumulator, object) => {
                    return accumulator + object.count;
                }, 0);
                dataArr.push(count);
                dataKeyXAxis.push(name);
                graphArr.push({ count, name });
            });
            setLineChartData({
                data: [{
                    type: 'line',
                    smooth: true,
                    data: dataArr,
                    areaStyle: {}
                }],
                xAxis: dataKeyXAxis
            });
        }
    };

    const handleDownload = async (type) => {
        let fields = {};
        let columns = analyticsColumns;
        let reportType = 'detailedanalytics';
        if (type === 'progress') {
            reportType = 'progressreport';
            columns = progressColumn;
        } else if (type === 'overview') {
            reportType = 'detailedoverview';
            columns = overViewColumn;
        }
        columns.forEach((itm) => {
            fields[itm.key] = itm.label;
        });
        setDownloadReportLoading({ ...downloadReportLoading, [type]: true });
        const filename = reportType;
        const filterData = {
            active: [],
            certificate_status: [],
            course: [],
            customer: [],
            pageno: 0,
            perpage: 9999999,
            project: [],
            report_type: reportType
        };
        let result = await reportService.getProjectReportData(`main/${reportType}`, filterData);

        if (result && result.status) {
            const { filter } = result?.data;
            filterData.customer = filter?.customer || [];
            filterData.project = filter?.project || [];
            filterData.course = filter?.course || [];
            let reportData = await reportService.getProjectReportData(`main/${reportType}`, filterData);
            if (reportData?.data && reportData?.data?.result) {
                let data = reportData.data.result;
                saveJsonAsCsv({ data, fields, filename });
            } else {
                notify('error', "Report data not found!")
            }
        }
        setDownloadReportLoading({ ...downloadReportLoading, [type]: false });
    }

    const handleView = (type) => {
        history.push(`/reporting/learning-service/${type}`);
    }

    let cardArr = [
        {
            title: "Total Active Courses",
            value: userReportCounts.activeCourseCount
        },
        {
            title: "Total Active Users",
            value: userReportCounts.activeUsersCount
        },
        {
            title: "Total Licenses Assigned",
            value: userReportCounts?.assignedLiceCount
        },
        {
            title: "Total Inactive Users",
            value: userReportCounts.inactiveUserCount
        }
    ];

    let reportCardArr = [
        {
            title: "Total Active Courses",
            subTitle: "Detailed analytics report",
            img: analyticImg,
            type: "analytic"
        },
        {
            title: "Total Active Courses",
            subTitle: "Overview report",
            img: overviewImg,
            type: "overview"
        },
        {
            title: "Total Active Courses",
            subTitle: "Progress report",
            img: progressImg,
            type: "progress"
        }
    ];

    if (userRole === 'user') {
        cardArr = [
            {
                title: "Total Courses",
                value: userReportCounts.totalCourseCount
            },
            {
                title: "Total Active Courses",
                value: userReportCounts.activeCourseCount
            },
            {
                title: "Total Completed Courses",
                value: userReportCounts.completedCourseCount
            },
            {
                title: "Self Learning Completion",
                value: userReportCounts.selfLearing
            }
        ];

        reportCardArr = [
            {
                title: "Total Open Projects",
                subTitle: "Detailed analytics report",
                img: analyticImg,
                type: "analytic"
            },
            {
                title: "Total Open Projects",
                subTitle: "Overview report",
                img: overviewImg,
                type: "overview"
            },
            {
                title: "Total Open Projects",
                subTitle: "Progress report",
                img: progressImg,
                type: "progress"
            }
        ];
    }

    const columns = [
        { label: "Course Name", key: 'course_name' },
        { label: "Category", key: 'category' },
        // { label: "Action", key: "action", actions: ["enroll"] }
    ];

    const handleItemClick = (data) => { };

    React.useEffect(() => {
        let active = true;
        const loadOverview = async () => {
            const tasks = [getCourseCatalogue(), getCorseCompletionGraph()];
            if (userRole === USER_ROLES.USER) {
                tasks.push(getUserOverviewReportCount());
            } else {
                tasks.push(getReportsGraphData(), getOverviewReportCount());
            }
            await Promise.allSettled(tasks);
            if (active) {
                setPageLoading(false);
            }
        };
        loadOverview();
        return () => {
            active = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCorseCompletionGraph = async () => {
        const graphData = await skillsAndTransformation.getCourseCompletionGraph()
        if (graphData && graphData.results) {
            setProgressOnCoursesList({
                ...progressOnCoursesList, data: graphData.results.map(itm => {
                    return itm.course_completion
                })
            });
            setDataKeyYAxis(graphData.results.map((itm, index) => {
                // return itm.course_name
                return "Course " + index
            }));
        }
    }

    return (
        <Layout>
            {pageLoading ? (
                <RouteSkeleton variant="report-overview" />
            ) : (
            <main className={classes.page}>
                <div className={classes.pageHeader}>
                    <Typography className={classes.pageEyebrow}>Reporting</Typography>
                    <Typography className={classes.pageTitle}>Overview</Typography>
                    <Typography className={classes.pageDescription}>
                        Review learning reports, key metrics, and course activity at a glance.
                    </Typography>
                </div>

                <Grid container spacing={2}>
                    {reportCardArr && reportCardArr.length > 0 ? (
                        reportCardArr.map(item => (
                            <Grid item xs={12} sm={6} md={4} key={item.type}>
                                <Report
                                    title={item.title}
                                    subTitle={item.subTitle}
                                    img={item.img}
                                    downloadReportLoading={downloadReportLoading}
                                    handleDownload={handleDownload}
                                    handleView={handleView}
                                    type={item.type}
                                />
                            </Grid>
                        ))
                    ) : null}
                </Grid>

                <Grid container spacing={2} className={classes.section}>
                    {cardArr && cardArr.length > 0 ? (
                        cardArr.map((item, index) => (
                            <Grid item xs={12} sm={6} md={6} lg={3} key={item.title + index}>
                                <ReportCard title={item.title} value={item.value} />
                            </Grid>
                        ))
                    ) : null}
                </Grid>

                {userRole === USER_ROLES.USER ? (
                    <Grid container spacing={2} className={classes.section}>
                        <Grid item xs={12} md={5}>
                            <div className={classes.panel}>
                                <h2 className={classes.sectionHeading}>Progress on Courses</h2>
                                <div className={classes.chartScroll}>
                                    <BarHorizontalChartWrapper
                                        data={progressOnCoursesList}
                                        dataKeyYAxis={dataKeyYAxis}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <div className={classes.panel}>
                                <div className={classes.sectionHeaderRow}>
                                    <h2 className={classes.sectionHeading} style={{ marginBottom: 0 }}>Popular Courses</h2>
                                    <button
                                        type="button"
                                        className={classes.viewAllLink}
                                        onClick={() => history.push('/skill-transformation/course-catalogue')}
                                    >
                                        View All
                                    </button>
                                </div>
                                <div className={classes.chartScroll}>
                                    <GenericTable
                                        columns={columns}
                                        loading={false}
                                        handleItemClick={handleItemClick}
                                        list={recommendedCourseslist}
                                        left={true}
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={2} className={classes.section}>
                        <Grid item xs={12} md={8}>
                            <ChartContainer
                                className={classes.panel}
                                titleClassName={classes.panelTitle}
                                title="Total Users By Course"
                            >
                                <div className={classes.chartScroll}>
                                    <LineChartWrapper data={lineChartData.data} dataKeyXAxis={lineChartData.xAxis} />
                                </div>
                                <p className={classes.chartAxisLabel}>Course Name</p>
                            </ChartContainer>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ChartContainer
                                className={classes.panel}
                                titleClassName={classes.panelTitle}
                                title="Top Courses By User/Progress"
                            >
                                <div style={{ minWidth: 0 }}>
                                    <PieChartWrapper data={bestCourses.map(itm => ({ name: itm.name, value: itm.count }))} />
                                </div>
                            </ChartContainer>
                        </Grid>
                    </Grid>
                )}
            </main>
            )}
        </Layout>
    );
}

export default Reporting;
